<form [formGroup]="loginForm" (ngSubmit)="login()">
  <div class="row">
    <div class="form-group col-md-8">
      <label>Email</label>
      <input class="form-control" [ngClass]="setClassInvalid(loginForm, 'email')" type="email" name="Email"
             formControlName="email" placeholder="Email" minlength="3" maxlength="100" autocomplete="email" required>
      <div class="invalid-feedback">Invalid email.</div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-8">
      <label>Password <small><a tabindex="-1" [routerLink]="" (click)="changeContent('forgot-password')">Forgot password?</a></small></label>
      <div class="input-group">
        <input class="form-control" [ngClass]="setClassInvalid(loginForm, 'password')" [type]="inputPasswordType" name="password"
               formControlName="password" placeholder="Password" minlength="6" autocomplete="current-password" required>
        <div class="input-group-append cursor-pointer" (click)="toggleInputPasswordType()"
             data-bs-toggle="tooltip" data-placement="top" data-delay="350" title="Show/Hide password">
          <span class="input-group-text">
            <i class="fa" [ngClass]="{'fa-eye': inputPasswordType === 'password', 'fa-eye-slash': inputPasswordType === 'text' }"></i>
          </span>
        </div>
        <div class="invalid-feedback">Password must be 6+ characters.</div>
      </div>
    </div>
  </div>
  <p class="small">
    No account? <a routerLink="/register">Register here</a>.</p>
  <button class="btn btn-primary" type="submit" [disabled]="!loginForm.valid">
    <i class="fa fa-sign-in"></i> Login
  </button>
</form>